import type { RouteRecordRaw } from 'vue-router'
import BookingAction from '../../pages/BookingAction.vue';

export const bookingActionRoute: RouteRecordRaw = {
  path: '/booking_confirm/action',
  name: 'booking_confirm/action',
  component: BookingAction,
}
